import { BookingCalendarFormValue } from '~components/AdServiceBooking/types';
import { AdData } from '@olxpwa-lib/utils-ad/types';
import { BOOKING_SUMMARY_STEPS } from '~components/BookingSummary/constants';
import React from 'react';

export type BookingCalendarSFCType = {
    bookingCalendar: {
        isShortTermRentals: boolean;
        renderAvailabilityCalendar: boolean;
        isGuestsFeatureEnabled: boolean;
    };
};

export type BookingSummaryLocationStateType = BookingCalendarSFCType & {
    ad: AdData | null;
    values: {
        dateFrom?: string & Date;
        dateTo?: string & Date;
    };
    timestamp: string;
};

export type GuestsObj = {
    guests: {
        adults: number;
        children: number;
        infants: number;
    };
};

export type BookingSummaryFormValue = BookingCalendarFormValue &
    Partial<GuestsObj>;

export type BookingSummaryProps = BookingCalendarFormValue &
    BookingSummaryLocationStateType & {
        step: BOOKING_SUMMARY_STEPS;
        setStep: React.Dispatch<React.SetStateAction<BOOKING_SUMMARY_STEPS>>;
    };

export type DatePickerProps = BookingCalendarFormValue;

export enum ResponseType {
    error = 'error',
    success = 'success',
    notRequested = 'notRequested'
}
